import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INVENTORY_BOOKS_ORDER_BASE_PATH } from '../../../../../../../../../features/inventory/books-order/inventory-books-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'inventory-books-orders',
        label: 'Inventory',
        to: INVENTORY_BOOKS_ORDER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
